import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDBodyText, FDEmphasisSurface, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { USDCurrencyFullFormatterNoFraction } from 'Helpers/Formats';
import { dataAttrs } from 'Helpers/Testing';

export const BaseAccountInfo = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDEmphasisSurface padding={2} {...dataAttrs('read-only-account-info')}>
      <MetaControlField attr={'name'} />
      <FDStack direction={'row'} alignItems={'center'} spacing={0.5}>
        <MetaControlField attr={'accountType'} />
        {'•'}
        <FDBodyText value={`${resource.meta().field('balance').attr('prompt')}:`} size={'sm'} />
        <FDBodyText size={'sm'} value={USDCurrencyFullFormatterNoFraction.format(resource.attr('balance'))} />
      </FDStack>
      <FDBodyText value={`${resource.meta().field('number').attr('placeholder')}`} size={'sm'} />
    </FDEmphasisSurface>
  );
};
